<template>
  <v-card>
    <v-toolbar flat color="white" density="compact">
      <!--FIELDSET DROPDOWN (USED IN FIELDSETS ONLY)-->
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-if="page.name === 'fieldsets'"
          v-model="selected_fieldset"
          :return-object="false"
          :items="fieldset_types"
          @update:model-value="showRecords"
          hide-details
          single-line>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('fieldset') }}</span>
        </template>
      </v-autocomplete>
      <!--ROLE DROPDOWN (USED IN ROLES ONLY)-->
<!--  <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-else-if="page.name === 'roles'"
          v-model="selected_department"
          :return-object="false"
          :items="departments"
          @update:model-value="showRecords"
          hide-details
          single-line>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('department') }}</span>
        </template>
      </v-autocomplete>-->
      <!--PROJECT ENGINEER DROPDOWN (USED IN PROJECT MANAGEMENT ONLY)-->
      <template v-else-if="page.name === 'projectmanagement'">
        <v-autocomplete
            class="reg-normal text-primary ml-5"
            base-color="border-tertiary"
            bg-color="secondary"
            density="compact"
            width="80px"
            v-model="project_management_filters.project_engineer_name"
            :return-object="false"
            :items="project_engineers"
            @update:model-value="showRecords"
            hide-details
            single-line
            clearable>
          <template #label>
            <span class="sm-normal text-subtle">{{ $store.getters.translate('project_engineer_name') }}</span>
          </template>
        </v-autocomplete>
        <v-autocomplete
            class="reg-normal text-primary ml-5"
            base-color="border-tertiary"
            bg-color="secondary"
            density="compact"
            width="100px"
            v-model="project_management_filters.discipline_engineer_name"
            :return-object="false"
            :items="discipline_engineers"
            @update:model-value="showRecords"
            hide-details
            single-line
            clearable>
          <template #label>
            <span class="sm-normal text-subtle">{{ $store.getters.translate('discipline_engineers') }}</span>
          </template>
        </v-autocomplete>
        <v-autocomplete
            class="reg-normal text-primary ml-5"
            base-color="border-tertiary"
            bg-color="secondary"
            density="compact"
            v-model="project_management_filters.root_asset_name"
            :return-object="false"
            :items="root_assets"
            @update:model-value="showRecords"
            hide-details
            single-line
            clearable>
          <template #label>
            <span class="sm-normal text-subtle">{{ $store.getters.translate('root_asset_name') }}</span>
          </template>
        </v-autocomplete>
      </template>
      <v-spacer/>
      <!--RIGHT-TOP CHIP BUTTONS-->
      <div class="chip-container">
        <!--EXCEL EXPORT-->
        <base-action-button v-if="page.name === 'documents'">
          <template #prepend><PhFileXls style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
          <template #default>
            <download-excel :data="getRecords" :name="page.name + '.xls'">
              {{ $store.getters.translate('export') }}
            </download-excel>
          </template>
        </base-action-button>
        <base-action-button v-else @action="showBaseExport">
          <template #prepend><PhFileXls style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("export") }}
        </base-action-button>
        <!--PROCEDURES PLANNING-->
        <base-action-button v-if="page.name === 'procedures'" @action="$router.push('/procedures-planning')">
          <template #prepend><PhCalendarCheck style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("planner") }}
        </base-action-button>
        <!--DEVIATION TEMPLATES-->
        <base-action-button v-if="page.name === 'standarddeviations' && canShowDeviationTemplates" @action="$router.push('/deviationtemplates')">
          <template #prepend><PhGear style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("deviationtemplates") }}
        </base-action-button>
        <!--DOCUMENT TYPES AND SUBTYPES-->
        <base-action-button v-if="page.name === 'documents' && canShowTypesAndSubtypes" @action="$router.push('/typesandsubtypes')">
          <template #prepend><PhGear style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("typesandsubtypes") }}
        </base-action-button>
        <!--IMPORT ASSETS-->
        <base-action-button v-if="page.name === 'projects' && canImportAssets" @action="$router.push('/importassets')">
          <template #prepend><PhArrowSquareIn style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("importassets") }}
        </base-action-button>
        <!--DEPARTMENTS-->
        <base-action-button v-if="page.name === 'employees'" @action="$router.push('/departments')">
          <template #prepend><PhUsersThree style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("departments") }}
        </base-action-button>
        <!--JOB TITLES-->
        <base-action-button v-if="page.name === 'employees'" @action="$router.push('/jobtitles')">
          <template #prepend><PhIdentificationCard style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("jobtitles") }}
        </base-action-button>
        <!--ACCESS LEVELS-->
<!--    <base-action-button v-if="page.name === 'employees'" @action="$router.push('/accesslevels')">
          <template #prepend><PhKey style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("accesslevels") }}
        </base-action-button>-->
        <!--MEETINGS-->
        <base-action-button v-if="page.name === 'projectmanagement'" @action="$router.push('/meetings')">
          <template #prepend><PhMonitor style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("meetings") }}
        </base-action-button>
        <!--TODOLISTS-->
        <base-action-button v-if="page.name === 'projectmanagement'" @action="$router.push('/todolists')">
          <template #prepend><PhListChecks style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("todolists") }}
        </base-action-button>
        <!--IMPORT PHASES-->
        <base-action-button v-if="page.name === 'projectmanagement' && canImportPhases" @action="$router.push('/importphases')">
          <template #prepend><PhArrowSquareIn style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("importphases") }}
        </base-action-button>
        <!--IMPORT CERTIFICATES-->
        <base-action-button v-if="page.name === 'inspectioncertificates' && canCreate" @action="$emit('certificatesImport')">
          <template #prepend><PhArrowSquareIn style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("import") }}
        </base-action-button>
        <!--CREATE FIELDSET-->
        <base-action-button v-if="page.name === 'fieldsets' && canCreate" @action="createFieldset">
          <template #prepend><PhPlus style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("create") }} {{ $store.getters.translate("fieldset") }}
        </base-action-button>
        <!--CREATE-->
        <base-action-button v-if="page.name !== 'notes' && page.name !== 'defectconsultations' && page.name !== 'standarddeviations' && page.name !== 'defectrepairs' && page.name !== 'projectmanagement' && page.name !== 'actionanddecisions' && page.name !== 'dnvverificationregisters' && canCreate" @action="$emit('create')">
          <template #prepend><PhPlus style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("create") }}
        </base-action-button>
        <!--FILTER-->
        <base-action-button @action="showFieldsSettings()">
          <template #prepend><PhSlidersHorizontal style="vertical-align: middle;" size="20"/></template>
        </base-action-button>
      </div>
      <v-menu v-if="page.name === 'projects' || page.name === 'punchlists' || page.name === 'actionanddecisions' || page.name === 'projectmanagement' || page.name === 'dnvverificationregisters' || page.name === 'inspectioncertificates'">
        <template #activator="{ props }">
          <v-btn elevation="0" icon v-bind="props">
            <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="getClosedState" @click="setClosedState(false)">
            <template #prepend><PhEye size="24"/></template>
            <v-list-item-title class="sm-normal link ml-2">
              <span v-if="page.name === 'projects' || page.name === 'punchlists' || page.name === 'actionanddecisions' || page.name === 'projectmanagement' || page.name === 'dnvverificationregisters'">
                {{ $store.getters.translate('show_closed') }}
              </span>
              <span v-else-if="page.name === 'inspectioncertificates'">
                {{ $store.getters.translate('show_with_files') }}
              </span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-else @click="setClosedState(true)">
            <template #prepend><PhEyeSlash size="24"/></template>
            <v-list-item-title class="sm-normal link ml-2">
              <span v-if="page.name === 'projects' || page.name === 'punchlists' || page.name === 'actionanddecisions' || page.name === 'projectmanagement' || page.name === 'dnvverificationregisters'">
                {{ $store.getters.translate('hide_closed') }}
              </span>
              <span v-else-if="page.name === 'inspectioncertificates'">
                {{ $store.getters.translate('hide_with_files') }}
              </span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div v-else style="margin-right: 16px;"/>
    </v-toolbar>
    <div style="overflow-x: auto; width: 100%;">
      <v-data-table
          :headers="fields"
          :items="getRecords"
          class="elevation-1"
          item-value="id"
          selectable-key="id"
          return-object
          :show-select="page.name !== 'roles'"
          v-model="selected"
          v-bind="footer_props"
          v-model:items-per-page="options.itemsPerPage"
          v-model:page="options.page"
          v-model:sort-by="options.sortBy"
          @update:current-items="current = $event">
        <!--CUSTOM SELECT-ALL WITH DROPDOWN-->
        <template #header.data-table-select>
          <v-chip variant="outlined" class="bulk-chip" rounded="pill" size="large" density="comfortable">
            <v-menu :disabled="selected.length === 0">
              <template #activator="{ props: menuProps, isActive }">
                <div class="chip-content">
                  <v-checkbox
                      :model-value="selected.length > 0 && selected.length === getRecords.length"
                      :indeterminate="selected.length > 0 && selected.length < getRecords.length"
                      @click="toggleSelectAll"
                      color="success"
                      hide-details/>
                  <v-btn v-bind="menuProps" v-if="selected.length" icon class="arrow-btn" elevation="0">
                    <PhCaretUp v-if="isActive" size="20"/>
                    <PhCaretDown v-else size="20"/>
                  </v-btn>
                </div>
              </template>
              <v-list v-if="selected.length > 0 && (($store.getters.getUser.superuser && page.name === 'projects') || canDelete || page.name === 'documents')">
                <!--CLOSE PROJECTS-->
                <v-list-item v-if="$store.getters.getUser.superuser && page.name === 'projects'" @click.stop="$emit('close', selected);">
                  <template #prepend><PhCheck size="24"/></template>
                  <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate("close") }} {{ selected.length }} {{ $store.getters.translate(page.name) }}</v-list-item-title>
                </v-list-item>
                <!--DELETE-->
                <v-list-item v-if="canDelete" @click.stop="bulkArchive">
                  <template #prepend><PhTrash size="24"/></template>
                  <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate("delete") }} {{ selected.length }} {{ $store.getters.translate(page.name) }}</v-list-item-title>
                </v-list-item>
                <!--DOWNLOAD DOCUMENTS-->
                <v-list-item v-if="page.name === 'documents'" @click.stop="$emit('download', selected)">
                  <template #prepend><PhDownloadSimple size="24"/></template>
                  <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate("download") }} {{ selected.length }} {{ $store.getters.translate(page.name) }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-chip>
        </template>
        <!--CUSTOM DESCRIPTION HEADER WITH GOLD V-CHIP-->
        <!--      <template #header.description="{ column }">
                    <v-chip size="small" rounded="lg" color="yellow" class="text-primary sm-bold" variant="elevated">{{ column.title }} </v-chip>
                  </template>-->
        <template #body.prepend>
          <tr>
            <td v-if="page.name !== 'roles'"/><!--EMPTY TD FOR CHECKBOXES-->
            <td v-for="(key, index) in Object.keys(response_fields)" :key="index">
              <base-field-in-table-header :advanced_search="advanced_search" :field_name="key" :field_type="response_fields[key]" :page_name="page.name" @showRecords="showRecords" @clearSearch="clearSearch"/>
            </td>
            <td v-if="page.name === 'projects' || ((page.name === 'procedures' || page.name === 'templates') && canCreate) || canEdit || canDelete" style="width: 80px;"/><!--EMPTY TD FOR ACTIONS-->
          </tr>
        </template>
        <template #body="{ items }">
          <tr v-for="item in items" :key="item.id" class="sm-normal text-primary" @click.ctrl="handleCtrlClick(item)">
            <td v-if="page.name !== 'roles'">
              <v-checkbox color="success" density="compact" v-model="selected" :key="item.id" :value="item" @click.shift="handleShiftClick(item)"/>
            </td>
            <td v-for="(key, index) in Object.keys(response_fields)" :key="index" @click.exact="$emit('preview', item)">
              <base-field-in-table :item="item" :field_name="key" :field_type="response_fields[key]" :page_name="page.name"/>
            </td>
            <!--ACTION BUTTONS-->
            <td style="text-align: center; width: 80px;" v-if="page.name === 'projects' || ((page.name === 'procedures' || page.name === 'templates') && canCreate) || canEdit || canDelete">
              <v-menu>
                <template #activator="{ props }">
                  <v-btn elevation="0" icon v-bind="props">
                    <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-if="page.name === 'projects'" @click="viewReport(item)">
                    <template #prepend><PhFilePdf size="24"/></template>
                    <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('report') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="$store.getters.getUser.superuser" @click="viewCustomPermissions(item)">
                    <template #prepend><PhLockOpen size="24"/></template>
                    <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('custom_permissions') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="(page.name === 'procedures' || page.name === 'templates') && canCreate" @click="makeCopy(item)">
                    <template #prepend><PhCopySimple size="24"/></template>
                    <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('copy') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="canEdit" @click="$emit('edit', item)">
                    <template #prepend><PhPencilSimpleLine size="24"/></template>
                    <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('edit') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="canDelete" @click="deleteRecord(item.id)">
                    <template #prepend><PhTrash size="24"/></template>
                    <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('delete') }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
          <tr v-if="getRecords.length === 0">
            <td :colspan="fields.length + 1" class="text-center">
              <span class="sm-normal link">{{ $store.getters.translate("nothing_found") }}</span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <base-create-fieldset ref="base_create_fieldset" @created="fieldsetCreated"/>
    <base-report ref="base_report"/>
    <base-export ref="base_export" :page="page" :data="getRecords"/>
    <base-modal-fields ref="base_modal_fields" :selected_model="page.model" @refresh="load()"/>
    <base-custom-permissions ref="base_custom_permissions" :selected_model="page.model"/>
  </v-card>
</template>

<script>
import { useAbility } from '@casl/vue';
import helpFunctions from "../../plugins/helpFunctions.js";
import BaseReport from "./BaseReport";
import BaseExport from "./BaseExport";
import BaseModalFields from "./BaseModalFields";
import BaseCustomPermissions from "./BaseCustomPermissions";
import BaseActionButton from "./BaseActionButton";
import BaseFieldInTable from "./BaseFieldInTable";
import BaseFieldInTableHeader from "./BaseFieldInTableHeader";
import BaseCreateFieldset from "./BaseCreateFieldset";
import {
  PhCalendarCheck,
  PhDotsThreeVertical,
  PhPencilSimpleLine,
  PhTrash,
  PhCopySimple,
  PhLockOpen,
  PhCaretUp,
  PhCaretDown,
  PhCheck,
  PhFileXls,
  PhDownloadSimple,
  PhMonitor,
  PhArrowSquareIn,
  PhPlus,
  PhSlidersHorizontal,
  PhListChecks,
  PhEye,
  PhEyeSlash,
  PhGear,
  PhFilePdf,
  PhIdentificationCard,
  PhUsersThree,
  PhKey
} from "@phosphor-icons/vue";

export default {
  components: {
    BaseCreateFieldset,
    BaseReport,
    BaseExport,
    BaseModalFields,
    BaseCustomPermissions,
    BaseActionButton,
    BaseFieldInTable,
    BaseFieldInTableHeader,
    PhKey, PhUsersThree, PhIdentificationCard, PhCalendarCheck, PhFilePdf, PhGear, PhEyeSlash, PhEye, PhListChecks, PhDotsThreeVertical, PhPencilSimpleLine, PhTrash, PhCopySimple, PhLockOpen, PhCaretDown, PhCaretUp, PhCheck, PhFileXls, PhDownloadSimple, PhMonitor, PhArrowSquareIn, PhPlus, PhSlidersHorizontal,
  },
  props: ["page"],
  setup() {
    const { can } = useAbility()
    return { can }
  },
  data() {
    return {
      selected: [],
      all_records: [],
      records: [],
      options: {},
      footer_props: helpFunctions.footer_props,
      advanced_search: {
        tags: [],
      },
      response_fields: {},
      fields: [],
      documents_limit: 10,
      current: [],
      //PROJECT MANAGEMENT FILTER VARIABLES
      project_management_filters: {
        project_engineer_name: null,
        discipline_engineer_name: null,
        root_asset_name: null
      },
      project_engineers: [],
      project_engineers_projectmanagement: {},
      discipline_engineers: [],
      discipline_engineers_projectmanagement: {},
      root_assets: [],
      root_assets_projectmanagement: {},
      //FIELDSETS FILTER VARIABLES
      selected_fieldset: null,
      fieldset_types: [],
      //ROLES FILTER VARIABLES
      //selected_department: null,
      //departments: [],
    };
  },
  created() {
    if(helpFunctions.getLocalStorageValue(this.page.name + "_options")) {
      this.options = helpFunctions.getLocalStorageValue(this.page.name + "_options");
      this.options.hide_closed_projects = true;
      this.options.hide_closed_punchlists = true;
      this.options.hide_closed_action_and_decisions = true;
      this.options.hide_closed_projectmanagement = true;
      this.options.hide_closed_dnvverificationregisters = true;
    }
    else {
      this.options = helpFunctions.table_options;
    }

    /*if(helpFunctions.getLocalStorageValue(this.page.name + "_advanced_search")) {
      this.advanced_search = helpFunctions.getLocalStorageValue(this.page.name + "_advanced_search");
    }*/

    if (this.page.name === 'projectmanagement') {
      this.loadProjectsWithProjectEngineerIDs();
    }
  },
  methods: {
    async load() {
      if (this.page.name === "documents") {
        this.all_records = [];
        this.$store.dispatch('setLoader', true);
        for (let i = 0; i < this.documents_limit; i++) {
          this.loadDocuments(i);
        }
      }
      let response = await helpFunctions.getModelsForTables(this.$toast, this.page.name);
      if (this.page.name !== "documents") {
        this.all_records = response.data;
      }

      //CUSTOM FIX FOR PROJECT MANAGEMENT TO SHOW PROJECT ENGINEERS IN TABLE
      if (this.page.name === 'projectmanagement') {
        this.response_fields.project_engineer_name = 'select_single';
        this.combineProjectEngineers();
      }
      //CUSTOM FIX FOR FIELDSETS TO GET FIELDSET TYPES
      else if (this.page.name === 'fieldsets') {
        this.getFieldsetTypes();
      }
      //CUSTOM FIX FOR ROLES TO GET DEPARTMENTS
      /*else if (this.page.name === 'roles') {
        this.getDepartments();
      }*/

      this.response_fields = helpFunctions.replaceIDwithNameBaseTable(response.fields);
      this.response_fields = helpFunctions.removeClosedField(this.response_fields);
      this.response_fields = helpFunctions.removeFieldsetTypeField(this.response_fields);

      let add_actions_column = this.page.name === 'projects' || ((this.page.name === 'procedures' || this.page.name === 'templates') && this.canCreate) || this.canEdit || this.canDelete;
      this.fields = helpFunctions.composeFields(this.response_fields, add_actions_column);
      if (this.page.name !== "documents") {
        this.showRecords();
      }
    },
    showRecords() {
      let sorted_array = this.all_records;
      if (this.page.name === "fieldsets") {
        sorted_array = sorted_array.filter(item => item.fieldset_type === this.selected_fieldset);
      }
      /*else if (this.page.name === "roles") {
        sorted_array = sorted_array.filter(item => item.department === this.selected_department);
      }*/
      else if(this.page.name === "projectmanagement") {
        if(this.project_management_filters.project_engineer_name) {
          sorted_array = sorted_array.filter(item => this.project_engineers_projectmanagement[this.project_management_filters.project_engineer_name].includes(item.id));
        }
        if(this.project_management_filters.discipline_engineer_name) {
          sorted_array = sorted_array.filter(item => this.discipline_engineers_projectmanagement[this.project_management_filters.discipline_engineer_name].includes(item.id));
        }
        if(this.project_management_filters.root_asset_name) {
          sorted_array = sorted_array.filter(item => this.root_assets_projectmanagement[this.project_management_filters.root_asset_name].includes(item.id));
        }
      }
      this.records = helpFunctions.showRecords(sorted_array, this.response_fields, this.advanced_search, this.page.name);
    },
    clearSearch(key) {
      this.advanced_search[key] = null;
      this.showRecords();
    },
    handleCtrlClick(item) {
      if(this.selected.find((el) => el.id === item.id)) {
        this.selected = this.selected.filter((el) => el.id !== item.id);
      }
      else {
        this.selected.push(item);
      }
    },
    handleShiftClick(item) {
        if (this.selected.length === 1 || this.selected.length === 2) {
          const IDs = [this.selected[1]?.id ?? item.id, this.selected[0].id];    // @click.shift is triggered before v-model="selected" updates, so we need to form a list of IDs from the item.
          let start = this.current.findIndex(el => el.raw.id === Math.min(...IDs));       // getting the starting element index
          let end = this.current.findIndex(el => el.raw.id === Math.max(...IDs));       //  end element index
          if(start > end) {
            let tmp = end;
            end = start;
            start = tmp;
          }
          for (let i = start; i < end; i++) {
            if (!this.selected.find((el) => el.id === this.current[i].key)) {
              this.selected.push(this.current[i].raw);
            }
          }
        }
    },
    toggleSelectAll() {
      const currentValues = this.current.map(item => item.value);
      const allSelected = currentValues.every(cv =>
          this.selected.some(sel => sel.id === cv.id)
      );

      if (allSelected) {
        this.selected = this.selected.filter(item =>
            !currentValues.some(cv => cv.id === item.id)
        );
      } else {
        const selectedIds = new Set(this.selected.map(item => item.id));
        const toAdd = currentValues.filter(cv => !selectedIds.has(cv.id));
        this.selected = [...this.selected, ...toAdd];
      }
    },
    async bulkArchive() {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.postCustomRoute(this.$toast, "bulk/remove", { model: this.page.model, ids: this.$lodash.map(this.selected, "id") }, true, true);
          this.selected = [];
          await this.load();
        }
      });
    },
    async loadDocuments(limit) {
      let start = limit * 10000;
      this.$http
          .get(this.$store.getters.appUrl + "v2/" + this.page.name + "?source=site" + "&start=" + start)
          .then((response) => {
            if (response.data.data) {
              this.all_records = [...this.all_records, ...response.data.data];
            }
            this.documents_limit--;
            if (this.documents_limit === 0) {
              this.$store.dispatch('setLoader', false);
              this.documents_limit = 10;
              this.showRecords();
            }
          }).catch((error) => {
            if (this.$store.getters.isLoggedIn) {
              this.$toast.error(error.message);
            }
            this.$store.dispatch('setLoader', false);
          });
    },
    async loadProjectsWithProjectEngineerIDs() {
      let response = await helpFunctions.getCustomRoute(this.$toast, "projects-with-project-engineers");
      this.project_engineers = Object.keys(response.project_engineers);
      this.project_engineers_projectmanagement = response.project_engineers;
      this.discipline_engineers = Object.keys(response.discipline_engineers);
      this.discipline_engineers_projectmanagement = response.discipline_engineers;
      this.root_assets = Object.keys(response.root_assets);
      this.root_assets_projectmanagement = response.root_assets;
      this.combineProjectEngineers();
    },
    combineProjectEngineers() {
      if (this.project_engineers && this.project_engineers.length > 0 && this.all_records && this.all_records.length > 0) {
        for (let i = 0; i < this.all_records.length; i++) {
          for (let x = 0; x < this.project_engineers.length; x++) {
            if (this.project_engineers_projectmanagement[this.project_engineers[x]].includes(this.all_records[i].id)) {
              this.all_records[i].project_engineer_name = this.project_engineers[x];
              break;
            }
          }
        }
      }
    },
    getFieldsetTypes() {
      this.fieldset_types = [];
      this.all_records.forEach((record) => {
        if (!this.fieldset_types.includes(record.fieldset_type)) {
          this.fieldset_types.push(record.fieldset_type);
        }
      });
      if(!this.selected_fieldset) {
        this.selected_fieldset = this.fieldset_types[0];
      }
    },
    /*getDepartments() {
      this.departments = [];
      this.all_records.forEach((record) => {
        if(!record.department) {
          record.department = 'Unknown';
        }
        if (!this.departments.includes(record.department)) {
          this.departments.push(record.department);
        }
      });
      if(!this.selected_department) {
        this.selected_department = this.departments[0];
      }
    },*/
    async deleteRecord(id) {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, id);
          await this.load();
        }
      });
    },
    async makeCopy(item) {
      this.$confirm(this.$store.getters.translate("are_you_sure")).then(async (res) => {
        if (res) {
          item.model = this.page.model;
          //CUSTOM ROUTE FOR PROCEDURES BECAUSE WE SHOULD COPY IT`S RELATIONS
          if(item.model === 'procedure') {
            await helpFunctions.postCustomRoute(this.$toast, "procedures/copy", item, true, true);
          }
          else {
            await helpFunctions.postCustomRoute(this.$toast, "bulk/copy", item, true, true);
          }
          this.selected = [];
          await this.load();
        }
      });
    },
    createFieldset() {
      this.$refs.base_create_fieldset.load();
    },
    fieldsetCreated(new_fieldset_name) {
      this.fieldset_types.push(new_fieldset_name);
      this.selected_fieldset = new_fieldset_name;
      this.showRecords();
    },
    viewReport(item) {
      this.$refs.base_report.load(item);
    },
    viewCustomPermissions(item) {
      this.$refs.base_custom_permissions.load(this.page.model, item.id);
    },
    showBaseExport() {
      this.$refs.base_export.load();
    },
    showFieldsSettings() {
      this.$refs.base_modal_fields.load();
    },
    setClosedState(new_state) {
      if(this.page.name === 'projects') {
        this.options.hide_closed_projects = new_state;
      }
      else if(this.page.name === 'punchlists') {
        this.options.hide_closed_punchlists = new_state;
      }
      else if(this.page.name === 'actionsanddecisions') {
        this.options.hide_closed_action_and_decisions = new_state;
      }
      else if(this.page.name === 'projectmanagement') {
        this.options.hide_closed_projectmanagement = new_state;
      }
      else if(this.page.name === 'dnvverificationregisters') {
        this.options.hide_closed_dnvverificationregisters = new_state;
      }
      else if(this.page.name === 'inspectioncertificates') {
        this.options.hide_with_files = new_state;
      }
    },
  },
  computed: {
    getClosedState() {
      if(this.page.name === 'projects') {
        return this.options.hide_closed_projects;
      }
      else if(this.page.name === 'punchlists') {
        return this.options.hide_closed_punchlists;
      }
      else if(this.page.name === 'actionsanddecisions') {
        return this.options.hide_closed_action_and_decisions;
      }
      else if(this.page.name === 'projectmanagement') {
        return this.options.hide_closed_projectmanagement;
      }
      else if(this.page.name === 'dnvverificationregisters') {
        return this.options.hide_closed_dnvverificationregisters;
      }
      else if(this.page.name === 'inspectioncertificates') {
        return this.options.hide_with_files;
      }
    },
    getRecords() {
      if(this.page.name === 'inspectioncertificates' && this.options.hide_with_files) {
        return this.records.filter((record) => !record.files || record.files.length === 0);
      }
      else if(this.page.name === 'projects' && this.options.hide_closed_projects) {
        return this.records.filter((record) => !record.closed);
      }
      else if(this.page.name === 'punchlists' && this.options.hide_closed_punchlists) {
        return this.records.filter((record) => !record.closed);
      }
      else if(this.page.name === 'actionanddecisions' && this.options.hide_closed_action_and_decisions) {
        return this.records.filter((record) => !record.closed);
      }
      else if(this.page.name === 'projectmanagement' && this.options.hide_closed_projectmanagement) {
        return this.records.filter((record) => !record.closed);
      }
      else if(this.page.name === 'dnvverificationregisters' && this.options.hide_closed_dnvverificationregisters) {
        return this.records.filter((record) => !record.closed);
      }
      else if(this.records) {
        return this.records;
      }
      else {
        return [];
      }
    },
    canCreate() {
      return this.can("create", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
    canEdit() {
      return this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
    canDelete() {
      return this.can("delete", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
    canImportAssets() {
      return this.can("show", this.$createEntity('importassets', { id: 0 }));
    },
    canImportPhases() {
      return this.can("show", this.$createEntity('importphases', { id: 0 }));
    },
    canShowDeviationTemplates() {
      return this.can("show", this.$createEntity('deviationtemplate', { id: 0 }));
    },
    canShowTypesAndSubtypes() {
      return this.can("show", this.$createEntity('typesandsubtype', { id: 0 }));
    },
  },
  watch: {
    options: {
      handler() {
        helpFunctions.setLocalStorageValue(this.page.name + "_options", this.options);
        if (this.all_records && this.all_records.length > 0) {
          this.showRecords();
        } else {
          this.load();
        }
      },
      deep: true,
    },
    advanced_search: {
      handler() {
        helpFunctions.setLocalStorageValue(this.page.name + "_advanced_search", this.advanced_search);
        this.options.page = 1;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.v-checkbox {
  display: flex;
}

.bulk-chip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-color: rgba(var(--v-theme-primary), 0.3);
  padding: 0px !important;
}

.chip-content {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.arrow-btn {
  width: 36px;
  height: 36px;
  min-width: 0;
  background-color: transparent;
}

.chip-container {
  display: flex;
  gap: 8px;
}

.v-text-field >>> input {
  font-size: 12px !important;
}
.v-text-field >>> label {
  font-size: 12px !important;
}

.v-card {
  position: static !important;
  overflow: visible !important;
}
</style>